import React, { useState } from 'react';
import * as api from 'api/vendor-request';
import { FlexRow } from 'components/styled-components';
import {
  Button,
  ButtonGroup,
  Popover,
  Classes,
  Intent,
  TextArea,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import colors from 'utils/colors';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import Moment from 'moment';

const Comment = ({ comment, user, fetch }) => {
  const [updatedComment, setComment] = useState(comment.content);
  const [editing, setEdit] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const setEditTrue = () => setEdit(true);
  const setEditFalse = () => setEdit(false);

  const handleUpdateValue = ({ target }) => {
    const { value } = target;
    setComment(value);
    setErrorMsg('');
  };

  const updateComment = () => {
    api
      .updateRequestComment(comment, updatedComment)
      .then(res => {
        fetch(comment.vendorRequestID);
        setEditFalse();
      })
      .catch(err => setErrorMsg(err.response.data.message));
  };

  const deleteComment = () => {
    api
      .deleteRequestComment(comment)
      .then(res => {
        fetch(comment.vendorRequestID);
      })
      .catch(err => setErrorMsg(err.response.data.message));
  };
  return (
    <CommentWrapper key={comment.vendorRequestCommentID}>
      <div style={{ width: '100%' }}>
        <CommentInfo>
          <UserIcon>
            <span>
              {comment.user.firstName && comment.user.firstName.charAt(0)}
              {comment.user.lastName && comment.user.lastName.charAt(0)}
            </span>
          </UserIcon>
          {`${comment.user.firstName} ${comment.user.lastName}`}
          <span
            style={{
              fontSize: '0.75rem',
              fontWeight: '700',
              marginLeft: '0.5rem',
            }}
          >
            {Moment(comment.timestamp).format('MMMM Do YYYY, h:mm:ss a')}
          </span>
          {!editing && user.userID === comment.user.userID && (
            <CommentControls>
              <ButtonGroup>
                <Button
                  icon={IconNames.EDIT}
                  minimal
                  onClick={setEditTrue}
                  intent={Intent.PRIMARY}
                />
                <Popover
                  content={
                    <div style={{ padding: '1rem' }}>
                      <p>Are you sure you want to delete this comment?</p>
                      <PopOverControls>
                        <Button
                          className={Classes.POPOVER_DISMISS}
                          style={{ marginRight: 10 }}
                          minimal
                        >
                          Cancel
                        </Button>
                        <Button
                          intent={Intent.DANGER}
                          className={Classes.POPOVER_DISMISS}
                          onClick={deleteComment}
                        >
                          Delete
                        </Button>
                      </PopOverControls>
                    </div>
                  }
                >
                  <Button
                    icon={IconNames.TRASH}
                    minimal
                    intent={Intent.DANGER}
                  />
                </Popover>
              </ButtonGroup>
            </CommentControls>
          )}
        </CommentInfo>
        <CommentContent>
          {editing ? (
            <>
              <FlexRow>
                <TextArea
                  fill={true}
                  value={updatedComment}
                  onChange={handleUpdateValue}
                  placeholder={'New note content...'}
                  maxLength={500}
                  minLength={1}
                />
                <div>
                  <Button
                    intent={Intent.PRIMARY}
                    minimal
                    text="SAVE"
                    onClick={updateComment}
                    disabled={
                      updatedComment === '' ||
                      updatedComment === comment.content
                    }
                  />
                  <Button minimal text="cancel" onClick={setEditFalse} />
                </div>
              </FlexRow>
              <ErrorWrapper>{errorMsg}</ErrorWrapper>
            </>
          ) : (
            <>
              {comment.content}
              <ErrorWrapper>{errorMsg}</ErrorWrapper>
            </>
          )}
        </CommentContent>
      </div>
    </CommentWrapper>
  );
};

const CommentWrapper = styled.div`
  display: flex;
  padding: 0.5rem;
  margin: 0.5rem;
  border: 1px solid transparent;
  &: hover {
    border-bottom: 1px solid ${colors.lightestGray};
    border-radius: 5px;
  }
`;

const CommentControls = styled.div`
  display: block;
  visibility: hidden;
  margin-left: 1rem;

  ${CommentWrapper}:hover & {
    visibility: visible;
  }
  @media screen and (max-width: 1025px) {
    ${CommentWrapper} & {
      visibility: visible;
    }
  }
`;

const CommentInfo = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-content: baseline;
  align-items: baseline;
`;

const UserIcon = styled.div`
  border-radius: 50px;
  background: ${colors.brandingPrimary};
  text-transform: uppercase;
  font-size: 1rem;
  height: 2.2rem;
  min-width: 2.2rem;
  margin-right: 1rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CommentContent = styled.div`
  margin: 0.5rem;
  color: ${colors.gray};
`;

const PopOverControls = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
`;

export default Comment;
